<div class="main-content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-8">
        <div class="card">
          <div class="card-header card-header-icon">
            <div class="card-icon crd-icon">
              <i class="material-icons">perm_identity</i>
            </div>
            <h4 class="card-title">Visitor</h4>
          </div>
          <div class="card-body">
            <form [formGroup]="form" (ngSubmit)="onSubmit()">
              <!-- Profile -->

              <div>
                <div class="row">
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="firstname"
                        >Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="firstname"
                        formControlName="firstname"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('firstname')"
                      >
                        Name is required
                      </div>
                    </div>
                  </div>
                  <div class="col-6 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="lastname"
                        >Last Name</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="lastname"
                        formControlName="lastname"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('lastname')"
                      >
                        Last name is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="username"
                        >Email</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="username"
                        formControlName="username"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('username')"
                      >
                        Email is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-5 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="indicative"
                        >Indicative</label
                      >
                      <select
                        class="form-control select"
                        id="indicative"
                        formControlName="indicative"
                      >
                        <option value="" disabled>Select </option>
                        <option *ngFor="let item of indicatives" [value]="item">
                          {{ item }}
                        </option>
                      </select>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('indicative')"
                      >
                        Indicative is required
                      </div>
                    </div>
                  </div>
                  <div class="col-7 col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="phone"
                        >Phone</label
                      >
                      <input
                        type="text"
                        class="form-control"
                        id="phone"
                        formControlName="phone"
                        (input)="formatPhone($event)"
                      />
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('phone')"
                      >
                        Phone is required
                      </div>
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="password"
                        >Password</label
                      >
                      <div class="d-flex">
                        <input
                          [type]="showPassword ? 'text' : 'password'"
                          class="form-control"
                          id="password"
                          formControlName="password"
                        />
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="cursor: pointer"
                            (click)="togglePasswordVisibility()"
                          >
                            <i class="material-icons">{{
                              showPassword ? "visibility_off" : "visibility"
                            }}</i>
                          </span>
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('password')"
                      >
                        Password is required
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="form-group">
                      <label class="bmd-label-floating" for="confirmPassword"
                        >Confirm password</label
                      >
                      <div class="d-flex">
                        <input
                          [type]="showPasswordTwo ? 'text' : 'password'"
                          class="form-control"
                          id="confirmPassword"
                          formControlName="confirmPassword"
                        />
                        <div class="input-group-append">
                          <span
                            class="input-group-text"
                            style="cursor: pointer"
                            (click)="togglePasswordVisibilityTwo()"
                          >
                            <i class="material-icons">{{
                              showPasswordTwo ? "visibility_off" : "visibility"
                            }}</i>
                          </span>
                        </div>
                      </div>
                      <div
                        class="invalid-feedback"
                        *ngIf="isFieldInvalid('confirmPassword')"
                      >
                        Confirm password is required
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <br />
              <div class="row text-center">
                <div class="col-12">
                  <button
                    type="submit"
                    class="btn btn-dark pull-right btn-update"
                    [disabled]="form.invalid"
                  >
                    Register
                  </button>
                </div>
              </div>
              <div class="clearfix"></div>
            </form>
            <!--  <button (click)="pru()" >prueba</button> -->
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
